import { render } from "./BranchesCarrousel.vue?vue&type=template&id=1bf39219"
import script from "./BranchesCarrousel.vue?vue&type=script&lang=js"
export * from "./BranchesCarrousel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__